/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" _fill="#fff" d="M9.75-.066c.78 0 1.41.632 1.41 1.411v7.061h7.059a1.406 1.406 0 010 2.813H11.16v7.058a1.411 1.411 0 01-2.822 0V11.22H1.28a1.406 1.406 0 010-2.813h7.06V1.345c0-.78.631-1.411 1.41-1.411z"/>'
  }
})
